import DiscussMariaAbout from "components/About/DiscussMariaAbout";
import HeroAbout from "components/About/HeroAbout";
import MainAbout from "components/About/MainAbout";
import Mission from "components/About/Mission";
import Quote from "components/About/Quote";
import SocialMedia from "components/About/SocialMedia";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import React from "react";

const About = () => {
  return (
    <div className="bg-darkbg">
      <HeroAbout />
      <Quote />
      <Mission />
      <MainAbout />
      <DiscussMariaAbout />
    </div>
  );
};

export default About;
